import { useEffect } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useScrollAnimation } from "@/hooks/use-scroll-animation";
import { cn } from "@/lib/utils";
import { useLocation } from "@/lib/locations";
import { getLocalContent } from "@/lib/city-content";

const getFaqs = (location: any) => {
  const localContent = getLocalContent(location.name, location.regionSlug, 'zh');
  return [
    { q: `${location.name}的家庭清洁费用是多少？`, a: `标准清洁服务起价$149。价格取决于房屋大小、服务类型和频率。使用我们的在线计算器即可获得精确的固定报价，无需上门评估。` },
    ...localContent.uniqueFaqs.map(f => ({ q: f.question, a: f.answer })),
    { q: "定期清洁比单次更便宜吗？", a: "是的！每周清洁节省35%，每两周节省30%，每月节省20%，与单次价格相比。" },
    { q: "清洁期间我需要在家吗？", a: "不需要。我们大多数客户清洁时不在家。预约时留下进入说明，我们完成后会安全锁好您的家门。" },
    { q: "你们是否持牌和投保？", a: "是的。Uplevel Cleaning在我们所有的服务区域完全持牌、投保和担保。" },
    { q: "200%保证是什么意思？", a: "如果您100%不满意，我们将在48小时内免费重新清洁遗漏区域。仍不满意？全额退款，无需任何解释。" },
    { q: "如何预约清洁服务？", a: "在uplevelcleaning.com上不到60秒即可在线预约。固定透明价格，无需电话联系。" },
    { q: "清洁需要多长时间？", a: "通常需要2到5小时，具体取决于房屋大小和状况。" },
    { q: "您的清洁产品对宠物和孩子安全吗？", a: "是的。我们使用专业清洁产品，正确使用时对宠物和儿童安全。" },
  ];
};

export const ChineseFAQ = ({ cityName }: { cityName: string }) => {
  const { ref, isVisible } = useScrollAnimation();
  const location = useLocation();
  const faqs = getFaqs(location);

  useEffect(() => {
    const id = "schema-zh-faq";
    let el = document.getElementById(id) as HTMLScriptElement | null;
    if (!el) {
      el = document.createElement("script");
      el.setAttribute("type", "application/ld+json");
      el.setAttribute("id", id);
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "inLanguage": "zh",
      "mainEntity": faqs.map(faq => ({
        "@type": "Question",
        "name": faq.q,
        "acceptedAnswer": { "@type": "Answer", "text": faq.a },
      })),
    });
    return () => { document.getElementById(id)?.remove(); };
  }, [faqs]);

  return (
    <section className="py-24 bg-background">
      <div className="container max-w-4xl">
        <div ref={ref} className={cn("text-center mb-16 anim-fade-up", isVisible && "is-visible")}>
          <h2 className="text-3xl md:text-5xl font-bold mb-4">常见问题</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            关于我们{cityName}清洁服务的所有问题解答。
          </p>
        </div>
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border rounded-xl px-6 bg-card shadow-sm">
              <AccordionTrigger className="text-left font-semibold text-base hover:text-primary transition-colors py-5">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed pb-5">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
